import {
  AbstractControl,
  FormGroup,
  ValidationErrors,
  FormControl,
} from "@angular/forms";
import * as moment from "moment";

export interface AllValidationErrors {
  control_name: string;
  error_name: string;
  error_value: any;
}

export interface FormGroupControls {
  [key: string]: AbstractControl;
}

export function getFormValidationErrors(
  controls: FormGroupControls
): AllValidationErrors[] {
  let errors: AllValidationErrors[] = [];
  Object.keys(controls).forEach((key) => {
    const control = controls[key];
    if (control instanceof FormGroup) {
      errors = errors.concat(getFormValidationErrors(control.controls));
    }
    const controlErrors: ValidationErrors = controls[key].errors;
    if (controlErrors !== null) {
      Object.keys(controlErrors).forEach((keyError) => {
        errors.push({
          control_name: key,
          error_name: keyError,
          error_value: controlErrors[keyError],
        });
      });
    }
  });
  return errors;
}

export class FormUtils {
  static customFormValidate(controls: any) {
    if (controls !== undefined) {
      Object.keys(controls).forEach((control) => {
        if (controls[control]?.controls !== undefined) {
          this.customFormValidate(controls[control]?.controls);
        }
        if (controls[control]?.status !== "DISABLED") {
          controls[control].markAsTouched({ onlySelf: true });
          controls[control].updateValueAndValidity({ onlySelf: true });
        } else {
          controls[control].markAsUntouched({ onlySelf: true });
          controls[control].markAsPristine({ onlySelf: true });
          // controls[control].updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  static customFormClearValidate(controls: any) {
    if (controls !== undefined) {
      Object.keys(controls).forEach((control) => {
        // setTimeout(() => {
        if (controls[control]?.controls !== undefined) {
          this.customFormClearValidate(controls[control]?.controls);
        }
        if (controls[control]?.status !== "DISABLED") {
          controls[control].markAsUntouched({ onlySelf: true });
          controls[control].updateValueAndValidity({ onlySelf: true });
        } else {
          controls[control].markAsUntouched({ onlySelf: true });
          controls[control].markAsPristine({ onlySelf: true });
          controls[control].updateValueAndValidity({ onlySelf: true });
        }
        // });
      });
    }
  }
  static omitSpecialChar(control: FormControl) {
    let input: string[];
    let isValid = true;

    if (control?.value?.length > 0) {
      input = Array.from(control?.value);

      input.forEach((value) => {
        const k = value.charCodeAt(0);
        if (
          !(
            (k > 64 && k < 91) ||
            (k > 96 && k < 123) ||
            k === 8 ||
            k === 32 ||
            (k >= 48 && k <= 57)
          )
        ) {
          isValid = false;
          return;
        }
      });
      return isValid ? null : { specialChar: true };
    }
  }

  static omitSpecialCharPhone(control: FormControl) {
    let input: string[];
    let isValid = true;

    if (control?.value?.length > 0) {
      input = Array.from(control?.value);

      input.forEach((value) => {
        const k = value.charCodeAt(0);
        if (!(k === 8 || k === 32 || (k >= 48 && k <= 57) || k === 43)) {
          isValid = false;
          return;
        }
      });
      return isValid ? null : { specialChar: true };
    }
  }

  static noWhitespaceValidator(control: FormControl) {
    let isWhitespace = false;

    if (control?.value && control?.value?.length > 0) {
      if (typeof (control.value || "")?.trim === "function") {
        isWhitespace =
          (control.value || "")?.trim()?.length === 0 ? true : false;
      }
    }
    const isValid = !isWhitespace;
    return isValid ? null : { whitespace: true };
  }

  static whitespaceBetweenValidator(
    control: FormControl
  ): { whitespace: boolean } | null {
    const { value } = control;
    if (!value || !value.length) {
      return null;
    }

    const hasWhitespace = value.split(" ").length > 1;
    return hasWhitespace ? { whitespace: true } : null;
  }

  static datePickerFormatterTime(date: Date) {
    return moment(date).format("YYYY/MM/DD HH:mm:ss");
  }

  static datePickerFormatter(date: Date) {
    return moment(date).format("YYYY/MM/DD");
  }

  static setGivenDateTimePickerFormat(date: Date, givenFormat: string) {
    if (!date) {
      return;
    }
    return moment(date).format(givenFormat);
  }

  static hexToRgb(hex: any): any {
    if (hex !== null && hex !== undefined) {
      const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, (m, r, g, b) => {
        return r + r + g + g + b + b;
      });

      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
          }
        : null;
    }
    return null;
  }

  static isObjectValidator(
    control: FormControl
  ): { notObject: boolean } | null {
    const { value } = control;
    return value && typeof value !== "object" ? { notObject: true } : null;
  }

  // custom validator to check that two fields match
  static mustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup): ValidationErrors | null => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
  
      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        // return if another validator has already found an error on the matchingControl
        return;
      }
  
      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    }
  }
}

// fazer utils para getForm para properties e categories
